import React from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay} from "swiper/modules";
import 'swiper/css';

const TextIconSlider = () => {
  const textIcons = [
    {
      id: 1,
      icon: "/images/getAQuote/settings.png",
      text: "Custom Parts Available"
    },
    {
      id: 2,
      icon: "/images/getAQuote/medalRibbonStar.png",
      text: "Shortlisted listings by professionals"
    },
    {
      id: 3,
      icon: "/images/getAQuote/shieldStar.png",
      text: "Worldwide Trusted Brands"
    }
  ];

  return (
    <section className='py-2 sm:py-3'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6'>
        {/* Mobile Slider (below 640px) */}
        <div className='block sm:hidden'>
          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            autoplay={{
              delay: 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            loop={true}
            loopAdditionalSlides={2}
            speed={800}
            className='text-icon-swiper'
          >
            {[...textIcons, ...textIcons].map(({ id, icon, text }, index) => (
              <SwiperSlide key={`${id}-${index}`}>
                <div className='flex items-center justify-center gap-2 py-2'>
                  <img src={icon} alt={text} className='w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0' />
                  <p className='text-sm sm:text-base font-semibold text-center'>{text}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Desktop Static Layout (640px and above) */}
        <div className='hidden sm:flex items-center justify-center flex-wrap gap-8 md:gap-12 lg:gap-20'>
          {textIcons.map(({ id, icon, text }) => (
            <div key={id} className='flex  items-center gap-2'>
              <img src={icon} alt={text} className='w-6 h-6 flex-shrink-0' />
              <p className='text-base md:text-lg font-semibold whitespace-nowrap'>{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TextIconSlider;
